export const skills = [
  { id: 1, skill: "HTML", icon: "devicon-html5-plain colored" },
  { id: 2, skill: "CSS", icon: "devicon-css3-plain colored" },
  { id: 3, skill: "JavaScript", icon: "devicon-javascript-plain colored" },
  { id: 4, skill: "Bootstrap", icon: "devicon-bootstrap-plain colored" },
  { id: 5, skill: "Tailwind", icon: "devicon-tailwindcss-plain colored" },
  { id: 6, skill: "React", icon: "devicon-react-original colored" },
  { id: 7, skill: "Figma", icon: "devicon-figma-plain colored" },
  { id: 8, skill: "Node.js", icon: "devicon-nodejs-plain colored" },
  { id: 9, skill: "MongoDB", icon: "devicon-mongodb-plain colored" },
  { id: 10, skill: "Firebase", icon: "devicon-firebase-plain colored" },
];
export const experiences = [
  {
    id: 1,
    role: "Freelance Developer",
    company: "Self-Employed",
    period: "July 2023 – Present",
    description:
      "Build responsive web apps and user interfaces with React, JavaScript, and CSS. Deliver high-quality work on schedule while collaborating with diverse clients."
  },
  {
    id: 2,
    role: "Front-End Developer",
    company: "Agent Pro",
    link: "https://my-agent-pro.netlify.app/",
    period: "May 2024 – Present",
    description:
      "Implement UI components in React, translate Figma designs to code, and refine user experience through modern web practices."
  },
];
